export default {
  //Used in search bar, user details, etc. -------------------------------
  meet: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper:
      "absolute left-5 flex items-center pointer-events-none text-primary",
    input:
      "w-full h-[40px] md:h-[44px] lg:h-[46px] rounded-full text-sm md:text-base text-text placeholder-text_secondary bg-paper focus:bg-paper border border-bordered px-4 py-2 focus:outline-none focus:ring-1 focus:ring-primary focus:border-none",
    input_with_icon: "pl-14",
    textarea:
      "w-full focus:transparent placeholder-text_secondary border border-none rounded-md focus:outline-none focus:ring-1 focus:border-none",
  },

}
